/**
 * Permission bitfield constants.
 * Stored as an INTEGER on the roles table.
 * Use hasPermission() to evaluate combined role permissions.
 */
export const Permissions = {
    MANAGE_SERVER: 1 << 0,
    MANAGE_ROLES: 1 << 1,
    MANAGE_CHANNELS: 1 << 2,
    VIEW_CHANNELS: 1 << 3,
    SEND_MESSAGES: 1 << 4,
    ATTACH_FILES: 1 << 5,
    DELETE_MESSAGES: 1 << 6,
    MANAGE_MESSAGES: 1 << 7,
    TIMEOUT_MEMBERS: 1 << 8,
    KICK_MEMBERS: 1 << 9,
    BAN_MEMBERS: 1 << 10,
    VIEW_AUDIT_LOG: 1 << 11,
    MANAGE_MEMBERS: 1 << 12,
    MANAGE_WEBHOOKS: 1 << 13,
    MANAGE_EMOJIS: 1 << 14,
    EMBED_LINKS: 1 << 15,
    MANAGE_THREADS: 1 << 16,
    CREATE_INVITES: 1 << 17,
    CONNECT_VOICE: 1 << 18,
    SPEAK: 1 << 19,
    STREAM: 1 << 20,
    PRIORITY_SPEAKER: 1 << 21,
    MUTE_MEMBERS: 1 << 22,
    DEAFEN_MEMBERS: 1 << 23,
    MOVE_MEMBERS: 1 << 24,
    MENTION_EVERYONE: 1 << 25,
    /** Bypasses all permission checks. Server owner always has this. */
    ADMINISTRATOR: 1 << 30,
};
/** Alias for STREAM — share screen in voice channels. */
export const CAN_STREAM = Permissions.STREAM;
/** Returns true if userPerms satisfies the required permission. ADMINISTRATOR bypasses all checks. */
export function hasPermission(userPerms, required) {
    if ((userPerms & Permissions.ADMINISTRATOR) !== 0)
        return true;
    return (userPerms & required) === required;
}
//# sourceMappingURL=permissions.js.map